<template>
  <div>
    <Loading :loading="loading"></Loading>
    <h2 v-if="!error">Okyanus Web Service</h2>
    <SsoError v-if="error" :message="error"></SsoError>
  </div>
</template>

<script>
/*
Hexagonia
RazPlus
SensationsEnglish
Deutschbesten
https://service.ueslms.com/#/okyanus/?ogrenciId=xxx&uygulama=Hexagonia
https://localhost:8080/#/okyanus/?ogrenciId=xxx&uygulama=Hexagonia

5. Sınıf
0x02000000CD7ADC80ED34849F6269BC829B35E1D9AE123DAF469382826B49F858746A1F3F

6. Sınıf
0x020000006CF622351E0E8B7A0DA113A96B7EB610841CA62916BC3D1E980F3A853E64FDD4

9. Sınıf
0x020000001BA4B8701796C2585E7075C010E47D2FF5F1D18B470EF8078A0B1CB464D7F1DF

10. Sınıf
0x0200000044755E72AA6FC9BD058BD7B8C0C4542CF73A841BB4040D752DAC960FD4CD1EE7

11. Sınıf
0x020000006FD7ACC7CFAC40C95BCAC68036020FCBBDC726EA74A60A01C3BFC96B9B3EBCE3
 */
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "Okyanus",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      error: null,
      apiKey: 'BC63F515-92E5-42BC-BBD7-AD00C64E8D3E',
      userKey: null,
      userRole: null,
      userId: 0,
      secretKey: "HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8",
      hexagoniaSecretKey: "HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8",
      uesPortalsSecretKey: "HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8",
      razPlusSecretKey: "DZYQSbQQKmruR4ZYOLD%s7163BZjoyViqF7gWy.A6Gd9JAyXCL!eNGsrEJVcPUe",
      // sensationsEnglishSecretKey: "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy",
      userData: {},
      platform: null,
      id_sube: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.uygulama) {
      this.platform = query.uygulama;
      this.id_sube = query.ID_SUBE
      this.getUserKey();
      this.getUserDetailsForUesLms();
    } else {
      console.log('HATA: uygulama parametresi bulunamadi.')
    }
  },
  methods: {
    getUserKey() {
      if (this.$route.query.ogrenciId) {
        this.userKey = this.$route.query.ogrenciId
        this.userRole = 'student'
      } else if (this.$route.query.ogretmenId) {
        this.userKey = this.$route.query.ogretmenId
        this.userRole = 'teacher'
      }
    },
    // OKYANUSTAN OGRENILEN ID UESLMS SERVISINE GONDERILEREK KULLANICI BILGILERI OGRENILIYOR
    async getUserDetailsForUesLms() {
      this.loading = true
      await axios.post('https://www.ueslms.com/api/v2/okyanus/user/check', { key: this.userKey, apikey: this.apiKey, subeid: this.id_sube })
          .then(response => {
            if (response.data.success) {
              this.userData = response.data.user

              // Bu kampüs/sınıf için hangi platform(lar)a yetkili olduğu artık burada
              // hardcode edilmiyor — Pusulam senkronundaki veriden (pusulam_classes.level +
              // pusulam_projects.project_name) backend tarafında hesaplanıp döndürülüyor
              // (bkz. OkyanusController::allowedPlatforms()). Öğrenci sınıf seviyesine göre,
              // öğretmen kampüs geneline göre kısıtlanıyor.
              const allowedPlatforms = response.data.allowed_platforms || [];
              if (!allowedPlatforms.includes(this.platform)) {
                this.fail('Sınıfınız/kampüsünüz için ' + this.platform + ' platformuna erişim tanımlı değil.');
              } else if (this.platform === 'Hexagonia') {
                this.goHexagonia()
              } else if (this.platform === 'RazPlus') {
                this.goRazPlus()
              } else {
                this.fail('Bilinmeyen platform: ' + this.platform);
              }
            } else {
              this.fail('Kullanıcı bilgileri alınamadı.');
            }
            this.loading = false
          })
          .catch(response => {
            console.log('ERR', response)
            this.loading = false
          })
    },

    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('Okyanus SSO:', message);
    },
    goHexagonia() {
      // console.log('this.userData', this.userData)
      const myObject = { class: [{}] };
      myObject.school_id = 3432; // okyanus
      myObject.campus_name = this.userData.campus_name;
      myObject.campus_id = this.userData.kurum_id;
      myObject.first_name = this.userData.first_name;
      myObject.last_name = this.userData.last_name;
      myObject.username = this.userData.username;
      myObject.roleType = this.userRole;
      myObject.password = (this.userRole === 'student') ? "123456" : 'Ues1234!';
      if (this.userRole === 'student') {
        // myObject.class = this.userData.class;
        // myObject.branch = this.userData.branch;
        myObject.class[0]['grade'] = this.userData.class;
        myObject.class[0]['branch'] = this.userData.branch;
      } else {
        myObject.classes = this.userData.classes;
      }
      // console.log('myObject', myObject)
      const textJson = JSON.stringify(myObject);
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.hexagoniaSecretKey).toString();
      if (this.userRole === 'student') {
        location.href = "https://service.ueslms.com/#/hexagonia/?sso=" + btoa(ciphertext);
      } else {
        location.href = "https://service.ueslms.com/#/uesportals/?sso=" + btoa(ciphertext);
      }
    },

    goRazPlus() {
      // console.log('userData2', this.userData);
      const myObject = {};
      myObject.school_id = 3432; // okyanus
      myObject.campus_id = this.userData.kurum_id;
      myObject.campus_name = this.userData.campus_name;
      myObject.first_name = this.userData.first_name;
      myObject.last_name = this.userData.last_name;
      myObject.username = this.userData.username;
      myObject.role_type = this.userRole;
      myObject.class = this.userData.class;
      myObject.branch = this.userData.branch;
      // console.log('myObject', myObject)
      const textJson = JSON.stringify(myObject);
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.razPlusSecretKey).toString();
      // if (this.userRole === 'student') {
      console.log('ciphertext', ciphertext)
      location.href = "https://service.ueslms.com/#/raz-plus/?sso=" + btoa(ciphertext);
      // } else {
      //   location.href = "https://service.ueslms.com/#/raz-plus-login";
      // }
    },

    /*goSensationsEnglish() {
      // console.log('userData', this.userData);
      const myObject = {};
      myObject.school_id = 3432; // okyanus
      myObject.school_name = 3432; // okyanus
      myObject.campus_id = 0;
      myObject.campus_name = this.userData.campus_name;
      myObject.first_name = this.userData.first_name;
      myObject.last_name = this.userData.last_name;
      myObject.username = this.userData.login_name;
      myObject.role_type = this.userRole;
      myObject.class = [
        {
          class: this.userData.class,
          branch: this.userData.branch,
        }
      ];
      // console.log('myObject', myObject)
      const textJson = JSON.stringify(myObject);
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.sensationsEnglishSecretKey).toString();
      location.href = "https://service.ueslms.com/#/sensations/?sso=" + btoa(ciphertext);
    },*/

    /*goDeutschbesten() {
      // console.log('userData', this.userData)
      location.href = "https://deutschbesten.com/#/?username=" + btoa(this.userData.login_name) + "&password=" + btoa((this.userRole === 'student') ? '123456' : 'Ues1234!');
    },*/

  }
}
</script>
